import { type ClassValue, clsx } from 'clsx'
import { format, formatDuration, intervalToDuration } from 'date-fns'
import createDOMPurify from 'isomorphic-dompurify'
import { twMerge } from 'tailwind-merge'

import { logger } from '../modules/utils'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getFormattedTime = (seconds: number): string => {
  const duration = intervalToDuration({
    start: 0,
    end: seconds * 1000,
  })

  return formatDuration(duration, {
    format: ['hours', 'minutes', 'seconds'],
  })
}

export const getFormattedDate = (
  date: Date | string,
  includeTime: boolean = false,
): string => {
  const isDate = date instanceof Date
  const parsedDate = isDate ? date : new Date(date)

  if (isNaN(parsedDate.getTime())) {
    logger.error(`Invalid date string: ${date}`)
    return ''
  }

  const dateFormatString = 'MM/dd/yy'
  const timeFormatString = 'HH:mm:ss'

  const fullFormatString = includeTime
    ? `${dateFormatString} - ${timeFormatString}`
    : dateFormatString

  return format(parsedDate, fullFormatString)
}

const DOMPurify = createDOMPurify()

const ALLOWED_TAGS: string[] = ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li']
const ALLOWED_ATTR: string[] = ['class']

export function sanitizeHtml(input: string): string {
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // prevent javascript: URLs and data attrs by default
    ALLOW_UNKNOWN_PROTOCOLS: false,
    ALLOW_DATA_ATTR: false,
  })
}
